module.exports = __webpack_public_path__ + "static/images/redirect.l2BMfYw.svg";